import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../modules/auth/store/reducer';
import globalReducer from '../modules/global/store/reducer';
import meReducer from '../modules/me/store/reducer';
import courseReducer from '../modules/course/store/reducer';
import userReducer from '../modules/user/store/reducer';
import emailReducer from '../modules/email/store/reducer';
import classReducer from '../modules/class/store/reducer';
import templateReducer from '../modules/template/store/reducer';
import subscriptionReducer from '../modules/subscription/store/reducer';
import reportReducer from '../modules/report/store/reducer';
import taskReducer from '../modules/task/store/reducer';
import notificationReducer from '../modules/notification/store/reducer';

const reducers = () =>
  combineReducers({
    auth: authReducer,
    course: courseReducer,
    class: classReducer,
    email: emailReducer,
    global: globalReducer,
    me: meReducer,
    subscription: subscriptionReducer,
    template: templateReducer,
    user: userReducer,
    report: reportReducer,
    task: taskReducer,
    notification: notificationReducer,
  });

export default reducers;
